exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uploaded-packages-table .no-overflow-ellipsis {\n  text-overflow: unset !important;\n  overflow: visible !important;\n  white-space: normal !important;\n}\n", ""]);

// exports
